import { Checkbox, Col, Form, Radio, Row } from "antd";
import React from "react";
import { connect } from "react-redux";
import Zipcode from '../../../../../CommonComponents/Zipcode/Zipcode';
import globalRegex from "../../../../../utils/regexMap";
import { recordError } from "../../../../../utils/commonUtil";
import { SelectComponentWrap } from "../../../../MyAccounts/Components/Step2LegacyOptions/Components/Tabs/styles";
import { FormItemWrapper, InputWrapper, TitleMarginTop, TitleWrapper } from "../../../../NPA/Pages/Step1Setup/styles";
import { emptyZip, getZipCode, jsonTemp, onAddressChangeHandler, prefillValuesAddressPrimary, prefillValuesAddressSecondary } from "../../../actions";
import { filterCountryData, filterCountryDesc, filterStateData, filterStateDesc } from "../../Data/DropDownData";
import { AddressWrap, CheckWrap, EmailTitleWrapper, EmailWrapper, Err, FlexWrap, LabelWrapper, PillButtonAdd, PrimaryElement, RadioWrapper, RowWrapper, TitleWrapperPrimaryAdress, Underlinelink, zipCodeErrorDiv, CheckBoxWrappered } from "../styles";
import InputComponent from "./InputComponent";
import SelectComponent from "./SelectComponent";
import PropTypes from "prop-types"
import { CapsuleButton } from "../../../../../CommonComponents/Commons/commonComponents";
import { RadioButton, CustomCheckbox } from "../../../../../CommonComponents/commonStyles";
class Addressform extends React.Component {
  constructor(props) {
    super(props);
    this.arr = [];
    this.secArr = [];
    this.state = {
      haschecked: true,
      line1: null,
      addresstype: null,
      zipcode: null,
      city: null,
      state: null,
      country: null
    };
  }
 componentDidUpdate = (prevState) => {
    if (this.props.isStep1Edit) {
      this.props.enableResetButton();
    }
    let advisorAddress = (prevState.advisorType === 'Primary') ? prevState.primaryAddress: prevState.secondaryAddress;
   if(JSON.stringify(prevState.zipCodeData) !== JSON.stringify(this.props.zipCodeData) ) {
      let advisorType = (prevState.advisorType === 'Primary') ? 'primaryAdvisor' : 'secondaryAdvisor';
      if (advisorAddress && advisorAddress.addresses &&  advisorAddress.addresses.length) {
        let addressTemp = [];
        advisorAddress.addresses.forEach((item, index) => {
         /**Set city from Google API Result */
          if (this.props.zipCodeData &&
              this.props.zipCodeData['zipcode' + (index + 1)] &&
              this.props.zipCodeData['zipcode' + (index + 1)].hasOwnProperty('city')) {
                if (this.props.zipCodeData['zipcode' + (index + 1)].city) {
                  item.city = this.props.zipCodeData['zipcode' + (index + 1)].city;
                } else {
                  item.city = item.city || '';
              }
          }
         /**Set State from Google API Result */
          if (this.props.zipCodeData &&
              this.props.zipCodeData['zipcode' + (index + 1)] &&
              this.props.zipCodeData['zipcode' + (index + 1)].hasOwnProperty('state'))  {
                if (this.props.zipCodeData['zipcode' + (index + 1)].state) {
                  item.state = this.props.zipCodeData['zipcode' + (index + 1)].state;
                } else {
                  item.state =  item.state || '';
              }
          }
          /**Set State and Country When zip is null */
          if (this.props.zipCodeData &&
            this.props.zipCodeData['zipcode' + (index + 1)] &&
            this.props.zipCodeData['zipcode' + (index + 1)].hasOwnProperty('zip') &&
            this.props.zipCodeData['zipcode' + (index + 1)].zip === null &&
            this.props.zipCodeData['zipcode' + (index + 1)].city === null &&
            this.props.zipCodeData['zipcode' + (index + 1)].state === null) {
              item.city = '';
              item.state = '';
          }
          addressTemp.push(item);
       });
        if (addressTemp.length ) {
          this.props.handleChange({
            [advisorType]: {
              addresses: addressTemp
            }
          });
          this.setState({city: null, state: null});
        }
      }
    }
 }
 advisorType = this.props.advisorType;
  userType = this.props.userType;
  handleAddressTypeDropdown = (dropdown = [],adress,index)=>{
    let addressTypeList = adress.filter((addr,addrIndex)=>{
      return  addrIndex != index;
    });
   return dropdown.filter((val)=>{
      return !addressTypeList.some((element)=>{
        return element.addresstype == val.desc
      })
    })
  }
 handleRadio = (e, radioIndex, advisorType, addresses) => {
    if (addresses) {      
      let arr1 = addresses;

      arr1.forEach((arr, index) => {
        arr.addressUpdated = true;
        if (index === radioIndex) {
          arr.primary = true;
        } else {
          arr.primary = false;
        }
      });
      this.props.handleChange({
        [advisorType]: {
          addresses: arr1
        }
      });
    }
  };
 onFocusAddressType = (e, addrIndex, addresses) => {
    let arr1 = addresses;
    let arr2 = [];
    arr1.filter((fil, index) => {
      if (index === addrIndex) {
        arr2.push(fil);
        return (fil.addresstype = e);
      }
    });
   if (arr2.length > 0) {
      if (
        arr2[0].addresstype === undefined ||
        arr2[0].addresstype === "" ||
        arr2[0].addresstype === "- Select -"
      ) {
        let addresses = this.state.addresstype;
        if (!addresses) {
          addresses = [];
        }
        addresses[addrIndex] = <Err>Please select address type.</Err>;
        this.setState({
          addresstype: addresses
        });
      } else {
        this.setState({
          addresstype: null
        });
      }
    }
  };
 dropDownHandleChange = (e, addrIndex, advisorType, property, addresses) => {
    let val = "";
    let removedAddressObj = null;
    if (addresses) {
      let arr1 = addresses;
      let arr2 = [];
      arr1.filter((fil, index) => {
        if (index === addrIndex) {
          arr2.push(fil);
          if (property === "state") {
            val = filterStateDesc(e, this.props.stateDropDown);
            if (fil.country === "0") {
              if (val.length > 0) {
                return ((fil[property] = val[0].value), (fil["addressUpdated"] = true));
              } else {
                return (fil[property] = "", fil["addressUpdated"] = true);
              }
            } else {
              let reg = /^[a-zA-Z]{0,100}$/;
              if (reg.test(e.target.value)) {
                return (
                  (fil[property] = e.target.value), (fil["addressUpdated"] = true)
                );
              }
            }
          } else if (property === "country") {            
            this.setState({
              zipcode: null,
              state: null,
              city: null
            });
            val = filterCountryDesc(e, this.props.countryDropDown);
            if (val.length > 0) {
              if (val[0].value !== "0") {
                if (this.props.shouldEmptyZip) {
                  fil.state = "";
                  fil.city = "";
                  fil.zipcode = "";
                  fil["addressUpdated"] = true;
                  this.props.emptyZip({
                    shouldEmptyZip: false
                  });
                }
              }
              if (fil["country"] === "0") fil["state"] = "";
              if (e === "United States") {
                fil["state"] = ""; 
                fil["zipcode"] = "";
                fil["city"] = "";
                fil["addressUpdated"] = true;
              } else {
                let oldCountry = fil["country"];
                if (oldCountry === "0" || oldCountry === "") {
                  fil["state"] = "";
                  fil["city"] = "";
                  fil["zipcode"] = "";
                  fil["addressUpdated"] = true;
                }
              }
             return (
                (fil[property] = val[0].value),
                (fil["addressUpdated"] = true)
              );
            } else {
              if (fil[property] === "0") fil["state"] = "";
              return (
                (fil[property] = ""), (fil["addressUpdated"] = true)
              );
            }
          } else if(property === 'addresstype'){

            if(fil.addressId != 0 )
            {
              removedAddressObj = {...fil}
            }  
            return (
              (fil[property] = e), (fil["addressUpdated"] = true)
            );
          } else {
            return (fil[property] = e, fil["addressUpdated"] = true);
          }
        }
      });
     if (arr2.length > 0) {
        if (arr2[0][property].length > 0) {
          let errors = this.state[property];
          if (!errors) {
            errors = [];
          }
          errors[addrIndex] = null;
          this.setState({
            [property]: errors
          });
        }
      }

      let emptyAddressObj = []
      if(removedAddressObj)
      {
      emptyAddressObj  = [{
        addressId:"",
       addressLine1: "",
       addressLine2: "",
       addressLine3: "",
        addressType: removedAddressObj.addresstype,
         city: "",
          country: "",
          primary: "",
        state: "",
        zipCode: ""
      }];
    }

     const  deletedAddressArray = advisorType == "primaryAdvisor"?[...this.props.primaryDeletedAddress,...emptyAddressObj]:[...this.props.secondaryDeletedAddress,...emptyAddressObj]
      
     this.props.handleChange({
        [advisorType]: {
          addresses: arr1,
          deletedAddress:deletedAddressArray
        }
      });
    }
  };

  onFocusLine1 = (e, addrIndex, addresses) => {
    let arr1 = addresses;
    let arr2 = [];
    arr1.filter((fil, index) => {
      if (index === addrIndex) {
        arr2.push(fil);
        return (fil.line1 = e.target.value);
      }
    });
   if (arr2.length > 0) {
      if (arr2[0].line1.trim().length < 1) {
        let line = this.state.line1;
       if (!line) {
          line = [];
        }
       line[addrIndex] = <Err>Please enter address.</Err>;
        this.setState({
          line1: line
        });
      } else if(arr2[0].line1.length > 50){
       let line = this.state.line1;
       if (!line) {
          line = [];
        }
       line[addrIndex] = <Err>Please enter a valid address</Err>;
        this.setState({
          line1: line
        });
     } else {
        this.setState({
          line1: null
        });
      }
    }
  };
 handleInputChange = (e, addrIndex, advisorType, property, addresses) => {
    if (addresses) {
      let arr1 = addresses;
      let arr2 = [];
      arr1.filter((fil, index) => {
        if (index === addrIndex) {
          arr2.push(fil);
          if (property === "zipcode") {
            if(fil["country"] === "0"){                            
              if (globalRegex.zipcode.test(e)) {
                return (
                  (fil[property] = e), (fil["addressUpdated"] = true)
                );
            }
            }else if(e.length <=20){         
              if (globalRegex.nonUSZipCode.test(e)) {
                return (
                  (fil[property] = e), (fil["addressUpdated"] = true)
                );
              }
            }
          } else {
            if (
              property === "line1" ||
              property === "line2" ||
              property === "line3"
            ) {
              if (e.length <= 50) {
                return (
                  (fil[property] = e),
                  (fil["addressUpdated"] = true)
                );
              }
            } else {
              if (property === "state") {
                let regex = globalRegex.state;
                if (regex.test(e)) {
                  return (
                    (fil[property] = e),
                    (fil["addressUpdated"] = true)
                  );
                }
              } else {
                if (property === "city") {
                  let regex = globalRegex.city;
                  if (regex.test(e)) {
                    return (
                      (fil[property] = e),
                      (fil["addressUpdated"] = true)
                    );
                  } else {
                    return (
                      (fil[property]),
                      (fil["addressUpdated"] = true)
                    );
                  }
                } else {
                  return (
                    (fil[property] = e),
                    (fil["addressUpdated"] = true)
                  );
                }
              }
            }
          }
        }
      });
          if(arr2 && arr2.length && arr2[0][property] && arr2[0][property].length){
          let error = [];
          if (property === "line1") {
            error = this.state.line1;
          } else if (property === "zipcode") {
            error = this.state.zipcode;
          }
          if (!error) {
            error = [];
          }
          error[addrIndex] = null;
          this.setState({
            [property]: error
          });
        }
     this.props.handleChange({
        [advisorType]: {
          addresses: arr1
        }
      });
    }
  };
 onFocusZipcode = (e, addrIndex, addresses, key) => {
    let arr1 = addresses;
    let arr2 = [];
    arr1.filter((fil, index) => {
      if (index === addrIndex) {
        arr2.push(fil);
        return (fil.zipcode = e.target.value);
      }
    });
    if (arr2.length > 0) {
      if (arr2[0].zipcode.length < 1) {
        let addresses = [];
        addresses[addrIndex] = <Err style={zipCodeErrorDiv}>Please enter zip code.</Err>;
        this.setState({
          zipcode: addresses
        });
      } else if(arr2[0].country === "0" && globalRegex.uszipCode.test(arr2[0].zipcode)) {
        let addresse = this.state.zipcode ? this.state.zipcode : [];
        addresse[addrIndex] = "";
        this.setState({
          zipcode: addresse
        });
      }else if(arr2[0].country !== "0" && !globalRegex.nonUSZipCode.test(arr2[0].zipcode)) {        
        let addresses = this.state.zipcode ? this.state.zipcode : [];
        addresses[addrIndex] = (
          <Err style={zipCodeErrorDiv}>
            Please enter a valid zipcode
          </Err>
        );
        this.setState({
          zipcode: addresses
        });
     }
      else if(arr2[0].country !== "0" && arr2[0].zipcode.length <= 20 ) {
        let addresses = this.state.zipcode ? this.state.zipcode : [];
        addresses[addrIndex] = "";
        this.setState({
          zipcode: addresses
        })
      } else if(arr2[0].country === "0"){
       let addresses = this.state.zipcode ? this.state.zipcode : [];
        addresses[addrIndex] = (
          <Err style={zipCodeErrorDiv}>
            The zip code must be in one of the following two formats: xxxxx or xxxxx-xxxx. Please correct to continue.
          </Err>
        );
        this.setState({
          zipcode: addresses
        });
      }else {
        let addresses = this.state.zipcode ? this.state.zipcode : [];
        addresses[addrIndex] = (
          <Err style={zipCodeErrorDiv}>
            Please enter valid zip code to continue.
          </Err>
        );
        this.setState({
          zipcode: addresses
        });
      }     
    }
  };
 onFocusCity = (e, addrIndex, addresses, type) => {
    let arr1 = addresses;
    let arr2 = [];
   arr1.filter((fil, index) => {
      let regex = globalRegex.city;
      if (index === addrIndex) {
        arr2.push(fil);
        if (type === "city") {
          return (fil.city = regex.test(e.target.value)
            ? e.target.value
            : fil.city);
        } else {
          return fil.country === e;
        }
      }
    });
   if (arr2.length > 0) {
      if (type === "city") {
        let regex = globalRegex.city
        if (arr2[0].city.trim().length < 1) {
          let addresses = this.state.city;
          if (!addresses) {
            addresses = [];
          }
          addresses[addrIndex] = <Err>Please enter city.</Err>;
          this.setState({
            city: addresses
          });
        } else if (arr2[0].city.length < 2) {
          let addresses = this.state.city;
          if (!addresses) {
            addresses = [];
          }
          addresses[addrIndex] = (
            <Err>City name is too short. Please correct to continue.</Err>
          );
          this.setState({
            city: addresses
          });
        } else if(!regex.test(arr2[0].city)){
          let addresses = this.state.city;
          if (!addresses) {
            addresses = [];
          }
          addresses[addrIndex] = (
            <Err>Please enter a valid city.</Err>
          );
          this.setState({
            city: addresses
          });
        }else {
          let addresses = this.state.city;  
          if (!addresses) {
            addresses = [];
          }
          addresses[addrIndex] = null;
          this.setState({
            city: addresses
          });
        }
      } else {
        if (arr2 && arr2[0] && arr2[0]["country"] && arr2[0].country.length < 1) {
          let addresses = this.state.country;
          if (!addresses) {
            addresses = [];
          }
          addresses[addrIndex] = <Err>Please enter country</Err>;
          this.setState({
            country: addresses
          });
        } else {
          let errorCountry = this.state.country;
          if (!errorCountry) {
            errorCountry = [];
          }
          if (arr2[0].country === "-1") {
            errorCountry[addrIndex] = <Err>Please enter country</Err>;
            this.setState({
              country: errorCountry
            });
          } else {
            errorCountry[addrIndex] = null;
            this.setState({
              country: errorCountry
            });
          }
        }
      }
    }
  };
 onFocusState = (e, addrIndex, addresses, type) => {
    let val = "";
    if (type !== "input") {
      val = filterStateDesc(e, this.props.stateDropDown);
    } else {
      val = e.target.value.trim();
    }
    let arr1 = addresses;
    let arr2 = [];
   if (val.length > 0) {
      arr1.filter((fil, index) => {
        if (index === addrIndex) {
          arr2.push(fil);
          if (arr2[0].country === "0") {
            return (fil.state = val[0].value);
          } else {
            return (fil.state = e.target.value);
          }
        }
      });
      if (arr2.length > 0) {
        let regex = globalRegex.state;
        if (arr2[0].state.trim().length < 1) {
          let addresses = this.state.state;
          if (!addresses) {
            addresses = [];
          }
          addresses[addrIndex] = <Err>Please enter state.</Err>;
          this.setState({
            state: addresses
          });
        } else if (arr2[0].state.trim().length < 2) {
          let addresses = this.state.state;
          if (!addresses) {
            addresses = [];
          }
          addresses[addrIndex] = (
            <Err>State name is too short. Please correct to continue.</Err>
          );
          this.setState({
            state: addresses
          });
        } else if(!regex.test(arr2[0].state.trim())) {
          let addresses = this.state.state;
          if (!addresses) {
            addresses = [];
          }
          addresses[addrIndex] = (
            <Err>Please enter a valid state.</Err>
          );
          this.setState({
            state: addresses
          });
        } else {
          if (val[0].value === "-1") {
            let addresses = this.state.state;
           if (!addresses) {
              addresses = [];
            }
           addresses[addrIndex] = <Err>Please enter state.</Err>;
            this.setState({
              state: addresses
            });
          } else {
            let addresses = this.state.state;
            if (!addresses) {
              addresses = [];
            }
            addresses[addrIndex] = null;
            this.setState({
              state: addresses
            });
          }
        }
      }
    } else {
      let addresses = [];
      addresses[addrIndex] = <Err>Please enter state.</Err>;
      this.setState({
        state: addresses
      });
    }
  };

  handleRemove = (e, key, advisorType, addresses) => {
    try {
      if (addresses) {
        let arr1 = addresses;
       let removedAddress =  arr1.splice(key, 1)[0];
        const removedAddressObj  = {
          addressId:"",
         addressLine1: "",
         addressLine2: "",
         addressLine3: "",
          addressType: removedAddress.addresstype,
           city: "",
            country: "",
            primary: "",
          state: "",
          zipCode: ""
        }
        if (arr1.length === 1) arr1[0]["primary"] = true;
        if (this.props.isStep1Edit) {
          let tempData = this.props.tempData.tempJSON;
          let index = 0;
          if (advisorType == "primaryAdvisor") {
            index = 0;
          } else {
            index = 1;
          }
          tempData.advisors[index].addresses = arr1;
          this.props.jsonTemp({
            tempJSON: tempData
          });
        } else {
          if(removedAddress.addressId != 0 )
          {
            const deletedAddressArray = advisorType == "primaryAdvisor"?[...this.props.primaryDeletedAddress,removedAddressObj]:[...this.props.secondaryDeletedAddress,removedAddressObj]
          
              this.props.handleChange({
                [advisorType]: {
                  addresses: arr1,
                  deletedAddress:deletedAddressArray
                }
              });
            
          }
          else
          {
          this.props.handleChange({
            [advisorType]: {
              addresses: arr1
            }
          });
        }
        }
      }
    } catch (error) {
      recordError(error);
    }
  };
  handleAdd = (advisorType, key, addresses) => {
    try {
      if (addresses) {
        let arr1 = addresses;
       arr1.push({
          addressId: 0,
          addresstype: "",
          line1: "",
          line2: "",
          line3: "",
          zipcode: "",
          city: "",
          state: "",
          country: "0",
          addressUpdated: false,
          primary: false,
        });
        if (arr1.length === 1) arr1[0]["primary"] = true;
        if (this.props.isStep1Edit) {
          let tempData = this.props.tempData.tempJSON;
          let index = 0;
          if (advisorType === "primaryAdvisor") {
            index = 0;
          } else {
            index = 1;
          }
          tempData.advisors[index].addresses = arr1;
          this.props.jsonTemp({
            tempJSON: tempData
          });
        } else {
          this.props.handleChange({
            [advisorType]: {
              addresses: arr1
            }
          });
        }
      }
    } catch(err) {
      recordError(err);
    }
  };
  
 renderForm = (addresses, advisor) => {
    const addSecondaryAdv = this.props.hasOwnProperty('addSecondaryAdv') ? this.props.addSecondaryAdv: false;
    if (
      (this.userType === "primary" && !addSecondaryAdv) ||
      this.userType === "secondary" ||
      this.userType === "full" ||
      (this.advisorType === "Secondary" &&
        this.props.isNewSecondaryAdd === true)
    ) {
      return (
        <RowWrapper>
          {addresses
            ? addresses.map((data, index) => {
                return (
                  <React.Fragment key={data.key}>

                    <Row gutter={24}>
                      <Col lg={{ span: 7 }} md={{ span: 10 }}>
                        <SelectComponent
                          aria-label="address-type"
                          role={false}
                          title="Address Type"
                          id={advisor + "AddressType" + index}
                          handleBlur={e =>
                            this.onFocusAddressType(e, index, addresses)
                          }
                          handleChange={e =>
                            this.dropDownHandleChange(
                              e,
                              index,
                              advisor,
                              "addresstype",
                              addresses
                            )
                          }
                          value={
                            data.addresstype === ""
                              ? "- Select -"
                              : data.addresstype
                          }
                          dropDownvalues={ this.handleAddressTypeDropdown(this.props.addressDropDown,addresses,index)}
                          placeholdert="Select Address type"
                          isSearch="false"
                        />
                        {this.state.addresstype
                          ? this.state.addresstype[index]
                          : null}
                      </Col>
                     {addresses && addresses.length > 1 ? (
                        <Col lg={{ span: 7 }} md={{ span: 10 }}>
                          <TitleWrapperPrimaryAdress>
                            <RadioWrapper>
                              <RadioButton
                                onChange={e =>
                                  this.handleRadio(e, index, advisor, addresses)
                                }
                                checked={data.primary}
                                id={advisor +"PrimaryAddresFlag" + index}
                              >
                                <PrimaryElement>Primary Address</PrimaryElement>
                              </RadioButton>
                            </RadioWrapper>
                            {data.primary !== true ? (
                              <Underlinelink
                                id={advisor +"AddressRemoveLink" + index}
                                onClick={e =>
                                  this.handleRemove(
                                    e,
                                    index,
                                    advisor,
                                    addresses
                                  )
                                }
                              >
                                Remove
                              </Underlinelink>
                            ) : null}
                          </TitleWrapperPrimaryAdress>
                        </Col>
                      ) : null}
                    </Row>
                   <Row gutter={16}>
                      <Col lg={{ span: 14 }} md={{ span: 10 }}>
                        <InputComponent
                          title="Address Line 1"
                          id={"AddressLine1" + this.advisorType + index}
                          handleBlur={e =>
                            this.onFocusLine1(e, index, addresses)
                          }
                          maxLength={50}
                          handleChange={e =>
                            this.handleInputChange(
                              e.target.value,
                              index,
                              advisor,
                              "line1",
                              addresses
                            )
                          }
                          ariaLabel="address line one "
                          placeholderText="Enter address line 1"
                          value={data.line1 !== "" ? data.line1 : undefined}
                        />
                        {this.state.line1 ? this.state.line1[index] : null}
                      </Col>
                    </Row>
                   <Row gutter={16}>
                      <Col lg={{ span: 14 }} md={{ span: 10 }}>
                        <InputComponent
                          title="Address Line 2 (optional)"
                          id={"AddressLine2" + this.advisorType + index}
                          handleChange={e =>
                            this.handleInputChange(
                              e.target.value,
                              index,
                              advisor,
                              "line2",
                              addresses
                            )
                          }
                          ariaLabel="Address line two"
                          max={350100}
                          placeholderText="Enter address line 2"
                          value={data.line2 !== "" ? data.line2 : undefined}
                        />
                      </Col>
                    </Row>
                   <Row gutter={16}>
                      <Col lg={{ span: 14 }} md={{ span: 10 }}>
                        <InputComponent
                          title="Address Line 3 (optional)"
                          id={"AddressLine3" + this.advisorType + index}
                          max={350100}
                          handleChange={e =>
                            this.handleInputChange(
                              e.target.value,
                              index,
                              advisor,
                              "line3",
                              addresses
                            )
                          }
                          placeholderText="Enter address line 3"
                          ariaLabel="Address line three"
                          value={data.line3 !== "" ? data.line3 : undefined}
                        />
                      </Col>
                    </Row>
                   {/** Add secondary advisor and my profile edit and edit my account*/}
                   <Row gutter={24}>
                      <Col lg={{ span: 7 }} md={{ span: 10 }}>
                        <FormItemWrapper
                          colon={false}
                          label={
                            <TitleMarginTop>
                              <TitleWrapper>Country</TitleWrapper>
                            </TitleMarginTop>
                          }
                        > 
                          <SelectComponent
                            showTitle={false}
                            id={advisor + "Country" + index}
                            isSearch="true"
                            title={"country"+ (index + 1 )}
                            name="country"                     
                            handleBlur={e =>
                              this.onFocusCity(e, index, addresses, "country")
                            }
                            handleChange={e => {
                              this.props.resetAllZipCode('zipcode' + (index + 1), 'country');
                              this.dropDownHandleChange(
                                e,
                                index,
                                advisor,
                                "country",
                                addresses
                              )
                            }}
                            default="United States"
                            placeholderText="Select country"
                            value={
                              this.props.zipCodeData['zipcode' + (index + 1 )] &&
                              this.props.zipCodeData['zipcode' + (index + 1 )].country ? this.props.zipCodeData['zipcode' + (index + 1 )].country :  this.props.countryDropDown ?
                              filterCountryData(
                                data.country,
                                this.props.countryDropDown
                              ).map(val => val.desc) : ''
                            }
                            dropDownvalues={this.props.countryDropDown}
                            disabled={this.props.zipCodeData['zipcode' + (index + 1 )] && this.props.zipCodeData['zipcode' + (index + 1 )].loading}
                          />
                          {this.state.country ? this.state.country[index] : null}
                        </FormItemWrapper>
                      </Col>
                      <Col lg={{ span: 7 }} md={{ span: 10 }}>
                        <FormItemWrapper
                          colon={false}
                          label={
                            <TitleMarginTop>
                              <TitleWrapper>Zip Code</TitleWrapper>
                            </TitleMarginTop>
                          }
                        >
                          <InputWrapper>
                            <Zipcode
                              id={advisor + "Zipcode" + index}
                              ariaLabel="Enter Zipcode"
                              isUS={data.country === '0'}
                              name='zipcode'
                              placeholder='Enter zipcode'
                              title={'zipcode' + (index+1)}
                              maxLength={data.country === '0' && '20'}
                              onBlur={event => {
                                this.onFocusZipcode(event, index, addresses, index);
                              }}
                              onChange={e =>   this.handleInputChange(e.target.value, index, advisor, "zipcode", addresses)}
                              value={data.zipcode !== '' ? data.zipcode : ''}
                            />
                            {this.state.zipcode ? this.state.zipcode[index] : null}
                          </InputWrapper>
                        </FormItemWrapper>
                      </Col>
                    </Row>
                   <Row gutter={24}>
                      <Col lg={{ span: 7 }} md={{ span: 10 }}>
                        <FormItemWrapper
                          colon={false}
                          label={
                            <TitleMarginTop>
                              <TitleWrapper>City</TitleWrapper>
                            </TitleMarginTop>
                          }
                        >
                          <InputWrapper>
                            <InputComponent
                              ariaLabel="city"
                              showTitle={false}
                              title={'city' + (index+1)}
                              id={"City" + this.advisorType + index}
                              name='city'
                              max={100}
                              handleBlur={event => {
                                 this.onFocusCity(event, index, addresses, "city");
                                }
                              }
                              handleChange={e => {
                                this.props.resetZipCode('zipcode' + (index + 1), 'city')
                                this.handleInputChange(
                                  e.target.value,
                                  index,
                                  advisor,
                                  "city",
                                  addresses
                                )
                                }}
                              value={
                                this.props.zipCodeData['zipcode' + (index + 1)] &&
                                this.props.zipCodeData['zipcode' + (index + 1)].city ? this.props.zipCodeData['zipcode' + (index + 1)].city : data.city !== '' ? data.city : undefined
                              }
                              disabled={this.props.zipCodeData['zipcode' + (index + 1)] && this.props.zipCodeData['zipcode' + (index + 1)].loading}
                              placeholderText="Enter city"
                            />
                            {this.state.city ? this.state.city[index]  : null}
                          </InputWrapper>
                        </FormItemWrapper>
                      </Col>
                      <Col lg={{ span: 7 }} md={{ span: 10 }}>
                        <FormItemWrapper
                          colon={false}
                          label={
                            <TitleMarginTop>
                              <TitleWrapper>State</TitleWrapper>
                            </TitleMarginTop>
                          }
                        >
                          {data.country === "0" && data.country !== "" ? (
                              <SelectComponentWrap>
                                <SelectComponent
                                  showTitle={false}
                                  title={'state' + (index + 1)}
                                  isSearch="true"
                                  defaultValue={-1}
                                  name='state'
                                  id={advisor + "state" + index}
                                  handleBlur={e =>
                                    this.onFocusState(e, index, addresses)
                                  }
                                  handleChange={e => {
                                    this.props.resetZipCode('zipcode' + (index + 1), 'state');
                                    this.dropDownHandleChange(
                                      e,
                                      index,
                                      advisor,
                                      "state",
                                      addresses
                                    )
                                  }
                                  }
                                  placeholderText="Select state"
                                  value={
                                    this.props.zipCodeData['zipcode' + (index + 1)] && 
                                    this.props.zipCodeData['zipcode' + (index + 1)].state ? this.props.zipCodeData['zipcode' + (index + 1)].state :  (data.state !== "- Select -")?
                                    this.props.stateDropDown &&
                                      filterStateData(
                                        data.state,
                                        this.props.stateDropDown
                                      ).map(val => val.desc)
                                    : "--"
                                  }
                                  disabled={this.props.zipCodeData['zipcode' + (index + 1)] && this.props.zipCodeData['zipcode' + (index + 1)].loading}
                                  dropDownvalues={this.props.stateDropDown}
                                />
                              </SelectComponentWrap>
                            ) : (
                              <InputComponent
                                ariaLabel="state"
                                title="State"
                                id={"state" + this.advisorType + index}
                                showTitle={false}
                                handleBlur={e =>
                                  this.onFocusState(e, index, addresses, "input")
                                }
                                max={100}
                                handleChange={e =>
                                  this.handleInputChange(
                                    e.target.value,
                                    index,
                                    advisor,
                                    "state",
                                    addresses
                                  )
                                }
                                value={
                                  data.state !== ""
                                    ? data.country === "0"
                                      ? this.props.stateDropDown &&
                                        filterStateData(
                                          data.state,
                                          this.props.stateDropDown
                                        )
                                      : data.state
                                    : undefined
                                }
                                placeholderText="Enter state"
                              />
                            )}
                            {this.state.state ? this.state.state[index] : null}
                          </FormItemWrapper>
                      </Col>
                    </Row>
                  </React.Fragment>
                );
              })
            : null}
          {addresses && addresses.length < 4 ? (
            
<CapsuleButton id={advisor + "AddAddressButton"}  onClick={() =>
                this.handleAdd(advisor, addresses.length + 1, addresses)
              } text="Add Address" iconType="add"/>

          ) : (
            <CapsuleButton   text="Add Address" iconType="add" disabled/>
          )}
        </RowWrapper>
      );
    } else {
      return (
        <RowWrapper>
          {addresses
            ? addresses.map((data, index) => {
                return (
                  <div>
                    <Row gutter={24}>
                      <Col lg={{ span: 7 }} md={{ span: 10 }}>
                        <SelectComponent
                          aria-label="address-type"
                          role={false}
                          title="Address Type"
                          defaultValue={-1}
                          id={advisor + "AddressType" + index}
                          handleBlur={e =>
                            this.onFocusAddressType(e, index, addresses)
                          }
                          disabled
                          value={
                            data.addresstype === ""
                              ? "--"
                              : data.addresstype
                          }
                          dropDownvalues={this.props.addressDropDown}
                          placeholderText="Select Address type"
                        />
                        {this.state.addresstype ? this.state.addresstype : null}
                      </Col>
                     {addresses && addresses.length > 1 ? (
                        <Col lg={{ span: 7 }} md={{ span: 10 }}>
                          <TitleWrapperPrimaryAdress>
                            <RadioWrapper>
                              <RadioButton disabled checked={data.primary}>
                                <PrimaryElement>Primary Address</PrimaryElement>
                              </RadioButton>
                            </RadioWrapper>
                          </TitleWrapperPrimaryAdress>
                        </Col>
                      ) : null}
                    </Row>
                   <Row gutter={16}>
                      <Col lg={{ span: 14 }} md={{ span: 10 }}>
                        <InputComponent
                          arialabel="addrLine1"
                          title="Address Line 1"
                          id={"AddressLine1" + this.advisorType + index}
                          max={350100}
                          disabled
                          placeholderText="Enter address line 1"
                          value={data.line1 !== "" ? data.line1 : undefined}
                        />
                        {this.state.line1 ? this.state.line1 : null}
                      </Col>
                    </Row>
                   <Row gutter={16}>
                      <Col lg={{ span: 14 }} md={{ span: 10 }}>
                        <InputComponent
                          arialabel="addrLine2"
                          title="Address Line 2 (optional)"
                          id={"AddressLine2" + this.advisorType + index}
                          disabled
                          max={350100}
                          placeholderText="Enter address line 2"
                          value={data.line2 !== "" ? data.line2 : undefined}
                        />
                      </Col>
                    </Row>
                   <Row gutter={16}>
                      <Col lg={{ span: 14 }} md={{ span: 10 }}>
                        <InputComponent
                          arialabel="addrLine3"
                          title="Address Line 3 (optional)"
                          id={"AddressLine3" + this.advisorType + index}
                          max={350100}
                          disabled
                          placeholderText="Enter address line 3"
                          value={data.line3 !== "" ? data.line3 : undefined}
                        />
                      </Col>
                    </Row>
                   <Row gutter={24}>
                      <Col lg={{ span: 7 }} md={{ span: 10 }}>
                        <InputComponent
                          arialabel="ZipCode"
                          title="Zip Code"
                          id={"ZipCodePrimary" + index}
                          disabled
                          value={data.zipcode !== "" ? data.zipcode : undefined}
                          placeholderText="Enter zipcode"
                        />
                      </Col>
                      <Col lg={{ span: 7 }} md={{ span: 10 }}>
                        <InputComponent
                          arialabel="City"
                          title="City"
                          id={"City" + this.advisorType + index}
                          disabled
                          max={100}
                          placeholderText="Enter city"
                          value={data.city !== "" ? data.city : undefined}
                        />
                      </Col>
                    </Row>
                   <Row gutter={24}>
                      <Col lg={{ span: 7 }} md={{ span: 10 }}>
                        {data.country === 0 ? (
                          <SelectComponent
                            title="State"
                            id={advisor + "state" + index}
                            disabled
                            defaultValue={-1}
                            placeholderText="Select state"
                            value={
                              data.state !== ""
                                ? this.props.stateDropDown &&
                                  filterStateData(
                                    data.state,
                                    this.props.stateDropDown
                                  ).map(val => val.desc)
                                : "--"
                            }
                            dropDownvalues={this.props.stateDropDown}
                          />
                        ) : (
                          <InputComponent
                            ariaLabel="Enter state"
                            title="State"
                            id={"state" + index}
                            disabled
                            value={
                              data.state !== ""
                                ? data.country === "0"
                                  ? this.props.stateDropDown &&
                                    filterStateData(
                                      data.state,
                                      this.props.stateDropDown
                                    )
                                  : data.state
                                : undefined
                            }
                            placeholderText="Enter state"
                          />
                        )}
                      </Col>
                      <Col lg={{ span: 7 }} md={{ span: 10 }}>
                        <SelectComponent
                          id={advisor + "Country" + index}
                          title="Country"
                          disabled
                          default="United States"
                          placeholderText="Select country"
                          value={
                            this.props.countryDropDown &&
                            filterCountryData(
                              data.country,
                              this.props.countryDropDown
                            ).map(val => val.desc)
                          }
                          dropDownvalues={this.props.countryDropDown}
                        />
                      </Col>
                    </Row>
                  </div>
                );
              })
            : null}
        </RowWrapper>
      );
    }
  };
 sameAddr = props => {
    this.setState({ haschecked: !this.state.haschecked });
    let addr = [];
    let addr2 = [];
    if (props.resetPrimary === false) {
      addr = props.primaryAddress && props.primaryAddress.addresses;  
     if (this.state.haschecked) {
        addr.filter(data => {
          if (data.primary === true) {
            data.addressId = 0;
            data.addressUpdated = true;
            addr2.push(data);
          }
        });
        if (this.props.isStep1Edit) {
          let tempData = this.props.tempData.tempJSON;
          tempData.advisors[1].addresses = addr2;
          this.props.jsonTemp({ tempJSON: tempData });
        } else {
          this.props.handleChange({
            ["secondaryAdvisor"]: {
              addresses: JSON.parse(JSON.stringify(addr2))
            }
          });
          this.setState({
            line1: null,
            addresstype: null,
            zipcode: null,
            city: null,
            state: null,
            country: null
          });
        }
      } else {
        addr2.push({
          addresstype: "",
          line1: "",
          line2: "",
          line3: "",
          state: "",
          city: "",
          zipCode: "",
          country: "0",
          key: 0,
          primary:true
        });
        if (this.props.isStep1Edit) {
          let tempData = props.tempData.tempJSON;
          tempData.advisors[1].addresses = addr2;
          this.props.jsonTemp({ tempJSON: tempData });
        } else {
          this.props.prefillValuesAddressSecondary({ addresses: addr2 });
        }
      }
    }
  };
 resetErrorValues = () => {
    this.setState({
      haschecked: false,
      line1: null,
      addresstype: null,
      zipcode: null,
      city: null,
      state: null,
      country: null
    });
  };
 render() {
    let advisor = "";
    let addresses;
    if (this.props.advisorType === "Primary") {
      advisor = "primaryAdvisor";
      addresses = this.props.primaryAddress.addresses;
    } else {
      advisor = "secondaryAdvisor";
      addresses = this.props.secondaryAddress.addresses;
    }
    if (this.props.resetErrors) {
      this.props.disableReset("addressInfo");
      this.resetErrorValues();
    }
   return (
      <div>
        <RowWrapper>
          <EmailWrapper>
            <FlexWrap>
              <AddressWrap>
                <EmailTitleWrapper>
                  <LabelWrapper>Address</LabelWrapper>
                </EmailTitleWrapper>
              </AddressWrap>
              {(this.advisorType === "Secondary" &&
                this.userType === "primary") ||
              (this.advisorType === "Secondary" &&
                this.userType === "secondary") ||
              (this.advisorType === "Secondary" && this.userType === "full") ||
              (this.advisorType === "Secondary" &&
                this.props.isNewSecondaryAdd === true) ? (
                this.advisorType === "Primary" ? null : (
                  <CheckBoxWrappered>
                    <CustomCheckbox data-test="sameAddrCheckBox" onChange={e => this.sameAddr(this.props)}>
                      <CheckWrap>Use same address as primary advisor</CheckWrap>
                    </CustomCheckbox>
                  </CheckBoxWrappered>
                )
              ) : null}
            </FlexWrap>
          </EmailWrapper>
          {this.renderForm(addresses, advisor)}
        </RowWrapper>
      </div>
    );
  }
}




const descvalueShape = PropTypes.shape({
  desc: PropTypes.string,
  value: PropTypes.string
})

const formShape = PropTypes.object;

const primaryAddressShape = PropTypes.shape({
  addresses: PropTypes.arrayOf(PropTypes.shape({
      addressId: PropTypes.number,
      addressUpdated: PropTypes.bool,
      addresstype: PropTypes.string,
      city: PropTypes.string,
      country: PropTypes.string,
      key: PropTypes.number,
      line1: PropTypes.string,
      line2: PropTypes.any,
      line3: PropTypes.any,
      primary: PropTypes.bool,
      state: PropTypes.string,
      zipcode: PropTypes.string
    }))
})

Addressform.propTypes =   {
  addSecondaryAdv: PropTypes.bool,
  addressDropDown: PropTypes.arrayOf(descvalueShape),
  advisorType: PropTypes.string,
  countryDropDown: PropTypes.arrayOf(descvalueShape),
  disableReset: PropTypes.func,
  emptyZip: PropTypes.func,
  enableResetButton: PropTypes.func,
  form: formShape,
  handleChange: PropTypes.func,
  hasOwnProperty: PropTypes.func,
  isNewSecondaryAdd: PropTypes.bool,
  isStep1Edit: PropTypes.any,
  jsonTemp: PropTypes.func,
  prefillValuesAddressSecondary: PropTypes.func,
  primaryAddress: primaryAddressShape,

    resetAllZipCode: PropTypes.func,
    resetErrors: PropTypes.bool,
    resetZipCode: PropTypes.func,
    secondaryAddress: primaryAddressShape,

    shouldEmptyZip: PropTypes.any,
    stateDropDown: PropTypes.arrayOf(descvalueShape),
    tempData: PropTypes.shape({
    tempJSON: PropTypes.shape({
      advisors: PropTypes.any
    })
  }),
  userType: PropTypes.string,
  zipCodeData: formShape
};

const WrappedAdressForm = Form.create({ name: "address" })(Addressform);

const mapStateToProps = state => ({
  primaryAddress: state.getIn(["myAccount", "primaryAdvisor", "addresses"]),
  secondaryAddress: state.getIn(["myAccount", "secondaryAdvisor", "addresses"]),
  primaryDeletedAddress: state.getIn(["myAccount", "primaryAdvisor","deletedAddress"]),
  secondaryDeletedAddress: state.getIn(["myAccount", "secondaryAdvisor","deletedAddress"]),
  resetPrimary: state.getIn(["myAccount", "primaryAdvisor", "reset"]),
  resetSecondary: state.getIn(["myAccountecondaryAdvisor", "reset"]),
  addressDropDown: state.getIn([
    "myAccount",
    "dropdownValues",
    "data",
    "postalAddressTypes"
  ]),
  stateDropDown: state.getIn(["myAccount", "dropdownValues", "data", "states"]),
  countryDropDown: state.getIn([
    "myAccount",
    "dropdownValues",
    "data",
    "countries"
  ]),
  shouldEmptyZip: state.getIn([
    "myAccount",
    "shouldEmptyZip",
    "shouldEmptyZip",
    "shouldEmptyZip"
  ]),
  isStep1Edit: state.getIn([
    "myAccount",
    "isStep1Edit",
    "isStep1Edit",
    "isStep1Edit"
  ]),
  tempData: state.getIn(["myAccount", "tempJSON", "tempJSON"])
});




export const mapDispatchToProps = (dispatch, ownProps) => ({
  handleChange: arr => dispatch(onAddressChangeHandler(arr)),
  prefillValuesAddressPrimary: arr =>
    dispatch(prefillValuesAddressPrimary(arr)),
  prefillValuesAddressSecondary: arr =>
    dispatch(prefillValuesAddressSecondary(arr)),
  getZipCode: data =>
    dispatch(
      getZipCode({
        zipCode: data.value,
        path:
          ownProps.advisorType === "Primary"
            ? "primaryAdvisor"
            : "secondaryAdvisor",
        index: data.index
      })
    ),
  emptyZip: data => dispatch(emptyZip(data)),
  jsonTemp: val => dispatch(jsonTemp(val))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(WrappedAdressForm);
